import React, { useCallback } from 'react';

import { useSessionContext } from '@/users/application/Session/SessionContext';
import { AlertManager } from '@dealroadshow/uikit/core/components/Alert';
import SubscribeButtonPremiumization from './SubscribeButtonPremiumization';
import {
  RestrictedButtonType,
} from '@/finsight/ui/common/components/Explanations/RestrictedAccessExplanation/RestrictedAccessExplanation';

interface ISubscribeButton {
  isSubscribed?: boolean,
  isFetching: boolean,
  isSubscribeAvailable?: boolean,
  isSpinnerVisible?: boolean,
  label?: string,
  subscriptionId: string,
  successMessage?: string | Function,
  subscribeBySSID: Function,
  requiredPlan?: string,
  restrictedButtonType?: RestrictedButtonType,
}

const SubscribeButton = ({
  subscriptionId,
  subscribeBySSID,
  successMessage,
  isSubscribed = false,
  label = '',
  isSubscribeAvailable = false,
  requiredPlan = '',
  restrictedButtonType = RestrictedButtonType.UpgradePlan,
  ...otherProps
}: ISubscribeButton) => {
  const { currentUser } = useSessionContext();

  const onButtonClickHandler = useCallback(() => {
    subscribeBySSID({ subscriptionId }, () => {
      if (successMessage) {
        if (typeof successMessage === 'string') {
          AlertManager.success(successMessage);
        } else if (typeof successMessage === 'function') {
          AlertManager.success(successMessage(currentUser));
        }
      }
    });
  }, [subscriptionId]);

  if (!label || !isSubscribeAvailable || !subscriptionId) {
    return null;
  }

  return (
    <SubscribeButtonPremiumization
      requiredPlan={ requiredPlan }
      label={ label }
      onClick={ onButtonClickHandler }
      isSubscribed={ isSubscribed }
      restrictedButtonType={ restrictedButtonType }
      { ...otherProps }
    />
  );
};

export default SubscribeButton;
